module.exports = __webpack_public_path__ + "static/media/waec.485ce058.png";